<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.album}}</h3>
</div>
<div class="modal-body">
    <form #kvForm="ngForm" name="kvForm" class="form-signin" style="max-width:400px">
        <div class="row">
            <div class="col-md-12">
                <label for="albumname">{{LOCALIZATION.name}}</label>
                <input [(ngModel)]='input.albumname' id="albumname" name="albumname" 
                	maxlength="{{limits.albumname}}" type="text" 
                	class="form-control" placeholder="Album Name" required autofocus />
                <span class="help-block pull-right">{{(input.albumname || '').length }}/{{limits.albumname}}</span>
				<span *ngIf="kvForm.form.controls['albumname']?.invalid && kvForm.form.controls['albumname']?.touched" class="required">
				  {{LOCALIZATION.required}}
				</span>                
            </div>
            <div class="col-md-12">
                <label for="description">{{LOCALIZATION.description}}</label>
				<textarea [(ngModel)]='input.description' id="description" name="description"  
					class="form-control" style="margin:0px; max-width:99%; height:200px; border:1px solid #9e9e9e;" 
					maxlength="{{limits.description}}" cols="90" placeholder="Album Description"  
					aria-label="Album Description"></textarea>                	
                    <span class="help-block pull-right">{{input.description.length||0}}/{{limits.description}}</span>
                </div>
        </div>
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="save()" [disabled]="!kvForm.valid">{{ isUpdate ? LOCALIZATION.update : LOCALIZATION.save}}</button>
</div>